// Tooltip styles - converted to plain objects for sx prop usage
export const tooltipStyles = {
  root: {
    display: "flex !important",
    minHeight: 50,
  },
  rootNoMinHeight: {
    display: "flex !important",
    minHeight: "auto",
  },
  reversed: {
    flexDirection: "row-reverse",
  },
  icon: (theme) => ({
    fill: theme.palette.tooltip.icon,
    marginTop: "auto",
    marginLeft: "auto",
    fontSize: 16,
  }),
  iconLeft: {
    paddingRight: 2,
  },
};

// Popover styles - converted to plain objects for sx prop usage
export const popoverStyles = {
  trigger: {
    cursor: "pointer",
  },
  root: {
    "& p": {
      marginTop: 0,
      color: "white",
    },
    "& p a": {
      color: "text.secondaryLinkLight",
      "&:hover": {
        color: "white",
      },
    },
    "& p:last-of-type": {
      margin: 0,
    },
  },
  paper: (theme) => ({
    backgroundColor: `${theme.components.MuiTooltip.styleOverrides.tooltip.backgroundColor} !important`,
  }),
  box: {},
  list: {
    color: "white",
    marginBottom: 0,
    "& li": {
      lineHeight: "20px",
    },
  },
};

export const baseCardStyle = (palette) => ({
  backgroundColor: "transparent",
  borderColor: palette.secondary.light,
  color: palette.secondary.main,
  fontSize: "1.4rem",
  justifyContent: "start",
  padding: "1rem 1.5rem",
  textTransform: "none",
});

export const cardHover = (palette) => ({
  transition: "all .22s ease-in-out",
  "&:hover,&:focus,&:focus-within": {
    transform: "translateY(-4px)",
    boxShadow:
      "0px 2px 1px -1px rgba(0, 0, 0, 0.1), 0px 5px 7px rgba(0, 0, 0, 0.05), 0px 4px 15px rgba(0, 0, 0, 0.05)",
    borderColor: palette.secondary.light,
    backgroundColor: palette.secondary.veryLight,
  },
});

export const menu = {
  menu: {
    display: "flex",
    flexWrap: "nowrap",
    alignItems: "center",
    alignContent: "center",
    paddingLeft: 2,
    paddingRight: 0,
    paddingBottom: 1,
    paddingTop: 1,
    minHeight: 20,
    borderBottom: "1px solid rgb(224, 224, 224)",
    borderRadius: 0,
  },
  menuActionsSecondary: {
    marginLeft: "auto",
  },
  searchString: {
    alignSelf: "center",
    margin: 0,
  },
};
